export default __webpack_public_path__ + "static/media/J720MANB4.83fee9c7.pdf";